import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorPanelComponent } from "./error_panel.component";
import { useTranslation } from "react-i18next";

// eslint-disable-next-line
function FallbackComponent({ error }) {
  const { t } = useTranslation();

  return (
    <ErrorPanelComponent>
      <p>{t("Error_Generic_Message")}</p>
      {
        // eslint-disable-next-line
        <pre>
          {t("Error_Detail_Label")} {error.message}
        </pre>
      }
      <em>{t("Error_Contact_Admin")}</em>
    </ErrorPanelComponent>
  );
}

export interface ExtRouteComponentProps {
  children?: React.ReactNode;
}

export const ErrorHandlerComponent: React.FC<ExtRouteComponentProps> = (
  props,
) => {
  return (
    <ErrorBoundary FallbackComponent={FallbackComponent}>
      {props.children}
    </ErrorBoundary>
  );
};
